import { Heading, HeadingType } from '../../../Typography';

export const DropdownHeading = ({
  name,
}: {
  name: string;
}): JSX.Element | null => {
  if (!name) return null;

  return (
    <Heading
      variant={HeadingType.h6}
      className="text-base font-semibold text-font-200 border-b pb-2 mb-2 mx-8 whitespace-nowrap uppercase sm:text-s-14 sm:mx-0"
      content={name}
    />
  );
};
